module.exports = __webpack_public_path__ + "img/donante-sol-toluca.8c0fd801.jpeg";